export enum InsightsPageTabsEnum {
  Analytics = 'analytics',
  Advanced = 'advanced',
  UnifiedAiInsights = 'unifiedAiInsights',
  ManageTopics = 'manageTopics',
  ManageAlerts = 'manageAlerts',
  ConversationRating = 'conversationRating',
}
